import { render, staticRenderFns } from "./regLogin.vue?vue&type=template&id=a6a16af2&scoped=true&"
import script from "./regLogin.vue?vue&type=script&lang=js&"
export * from "./regLogin.vue?vue&type=script&lang=js&"
import style0 from "./regLogin.vue?vue&type=style&index=0&id=a6a16af2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a16af2",
  null
  
)

export default component.exports